import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    curFileName:'',
    modelLoadingStatus:false,
    dataModel:null,
    layers:null,
    //左手边抽屉状态
    generationParamsDrawer:false,
    drawPlanningLineDrawer:false,
    subdivisionDrawer:false,
    facadeModeDrawer:false,
    // 交互通讯部分
    isDataElementSelected:false,
    curSelectedDataElement:null,
    curSelectedDataElementMaterial:null,
    globalGenerationParams:null,
    // 是否允许绘制线段
    allowDrawLine:false,
    // 规划线坐标
    planningLineCoords:null,
    // 点击重新绘制之后会清楚之前的
    redrawPanningLine:false,
    // 立面生成模式
    facadeMode:1,
    // 去生成
    goGeneration:false,
    // 如果生成成功这里是true
    generationStatus:false,
    // normalDisplayModel:true,
    // 点击是否从右侧弹出分析的drawer
    urbanAnalysisDrawerStatus:false,
    // 分析
    axisAnalysis:false,
    FARAnalysis:false,
    greenRateAnalysis:false,
    waterAnalysis:false,
    // 是否选中某个项目
    curSelectedProject:null,
    isProjectSelected:false,
    // 具体某块场地的项目分析
    functionAnalysis:false,
    towerCoreAnalysis:false,
    landscapeAnalysis:false,
    // 标签们
    FARFlag:null,
    greenRateFlag:null,
    siteIdFlag:null,
    //是否开始操作提示
    tipStatus:false,
    generateTipStatus: false,
    // websocket实例对象
    socket: null,
  },
  mutations: {
    //上传文件的名字
    GETFILENAME(state, fileName){
      state.curFileName = fileName
    },
    // DataModel更新
    GETDATAMODEL(state, dataModel){
      state.dataModel = dataModel
    },
    // 模型加载状态
    CHANGEMODELSTATUS(state, status){
      state.modelLoadingStatus = status
    },
    // 全局生成参数
    SAVEGLOBALGENERATIONPARAMS(state, params){
      state.globalGenerationParams = params
    },
    // 改变左工具栏抽屉的状态
    CHANGEGENERATIONPARAMSDRAWER(state, status){
      state.generationParamsDrawer = status
    },
    CHANGEDRAWPLANNINGLINEDRAWER(state, status){
      state.drawPlanningLineDrawer = status
    },
    CHANGESUBDIVISIONDRAWER(state, status){
      state.subdivisionDrawer = status
    },
    CHANGEFACADEMODEWARDER(state, status){
      state.facadeModeDrawer = status
    },
    // 获取图层名称
    GETFILELAYER(state, layers){
      state.layers = layers
    },
    // 是否有物件被选中
    ISDATAELEMENTSELECTED(state, status){
      state.isDataElementSelected = status
    },
    // 当前被选中的物件
    SELECTEDDATAELEMENT(state, dataElement){
      console.log('one object has been selected')
      state.curSelectedDataElement = dataElement
    },
    // 物件将要被改变的材质
    CHANGEMATERIAL(state, material){
      state.curSelectedDataElementMaterial = material
    },
    // 改变是否可以绘制线的状态
    CHANGEDRAWLINESTATUS(state, status){
      state.allowDrawLine = status
    },
    // 获取当前规划线坐标
    GETPLANNINGLINECOORDS(state, coords){
      state.planningLineCoords = coords
    },
    SETFACADEMODE(state, mode){
      state.facadeMode = mode
    },
    GOGENERATION(state, status){
      state.goGeneration = status
    },
    // 生成状态
    GETGENERATIONSTATUS(state, status){
      state.generationStatus = status
    },
    // 控制是否弹出右侧的分析菜单
    CHANGEURBANANALYSISDRAWERSTATUS(state, status){
      state.urbanAnalysisDrawerStatus = status
    },
    AXISANALYSISSTATUS(state, status){
      state.axisAnalysis = status
    },
    FARANALYSISSTATUS(state, status){
      state.FARAnalysis = status
    },
    GREENANALYSISSTATUS(state, status){
      state.greenRateAnalysis = status
    },
    WATERANALYSIS(state, status){
      state.waterAnalysis = status
    },
    // 把选中的项目box中的id放到这里
    GETSELECTPROJECT(state, element){
      state.curSelectedProject = element
    },
    PROJECTSELECTSTATUS(state, status){
      state.isProjectSelected = status
    },
    PROJECTANALYSISSTATUS(state, status){
      if (status ===0){
        state.functionAnalysis = true
        state.towerCoreAnalysis = false
        state.landscapeAnalysis = false
      }else if (status ===1){
        state.functionAnalysis = false
        state.towerCoreAnalysis = true
        state.landscapeAnalysis = false
      }
      else if (status ===2){
        state.functionAnalysis = false
        state.towerCoreAnalysis = false
        state.landscapeAnalysis = true
      }else{
        state.functionAnalysis = false
        state.towerCoreAnalysis = false
        state.landscapeAnalysis = false
      }
    },
    GETFARFLAGS(state, flags){
      state.FARFlag = flags
    },
    GETGREENFLAGS(state, flags){
      state.greenRateFlag = flags
    },
    GOCHANGETIPSTATUS(state,status){
      state.tipStatus = status
    },
    GOGENERATETIPSTATUS(state,status){
      state.generateTipStatus = status
    },
    CREATESOCKET(state, socket) {
      state.socket = socket;
    },
  },
  actions: {
    //获取文件名
    getFileName(context, fileName){
      context.commit('GETFILENAME', fileName)
    },
    getDataModel(context, dataModel){
      console.log('data model has been update.')
      context.commit('GETDATAMODEL', dataModel)
    },
    changeModelLoadingStatus(context, status){
      context.commit('CHANGEMODELSTATUS', status)
    },
    saveGlobalGenerationParams(context, params){
      context.commit('SAVEGLOBALGENERATIONPARAMS', params)
    },
    changeGenerationParamsDrawerStatus(context, status){
      context.commit('CHANGEGENERATIONPARAMSDRAWER', status)
    },
    changeDrawPlanningLineDrawerStatus(context, status){
      context.commit('CHANGEDRAWPLANNINGLINEDRAWER', status)
    },
    changeSubdivisionDrawerStatus(context, status){
      context.commit('CHANGESUBDIVISIONDRAWER', status)
    },
    changeFacadeModeDrawerStatus(context, status){
      context.commit('CHANGEFACADEMODEWARDER', status)
    },
    // 获取文件图层名
    getFileLayers(context, layers){
      context.commit('GETFILELAYER', layers)
    },
    //改变是否有物件被选中的状态
    changeDataElementSelected(context, status){
      context.commit('ISDATAELEMENTSELECTED', status)
    },
    //获取当前被选中的物件
    getSelectedDataElement(context, dataElement){
      context.commit('SELECTEDDATAELEMENT', dataElement)
    },
    // 改变物件材质
    getSelectedDataElementMaterial(context, material){
      context.commit('CHANGEMATERIAL', material)
    },
    changeDrawLineStatus(context, status){
      context.commit('CHANGEDRAWLINESTATUS', status)
    },
    setFacadeMode(context, mode){
      context.commit('SETFACADEMODE', mode)
    },
    // 获取新的线段的坐标
    getPlanningLineCoords(context, coords){
      context.commit('GETPLANNINGLINECOORDS', coords)
    },
    goForGeneration(context, status){
      context.commit('GOGENERATION', status)
    },
    // 获得生成状态
    getGenerationStatus(context, status){
      context.commit('GETGENERATIONSTATUS', status)
    },
    // 获得是否弹出右侧整体方案分析的draser
    changeUrbanAnalysisDrawerStatus(context, status){
      context.commit('CHANGEURBANANALYSISDRAWERSTATUS', status)
    },
    changeAxisAnalysis(context, status){
      context.commit('AXISANALYSISSTATUS', status)
    },
    // 改变far显示模式状态
    changeFARAnalysisStatus(context, status){
      context.commit('FARANALYSISSTATUS', status)
    },
    // 显示绿化率
    changeGreenAnalysisStatus(context, status){
      context.commit('GREENANALYSISSTATUS', status)
    },
    changeWaterAnalysisStatus(context, status){
      context.commit('WATERANALYSIS', status)
    },
    getSelectProject(context,element){
      context.commit('GETSELECTPROJECT',element)
    },
    changeSelectProjectStatus(context, status){
      context.commit('PROJECTSELECTSTATUS',status)
    },
    changeProjectAnalysis(context, status){
      context.commit('PROJECTANALYSISSTATUS',status)
    },
    getFARFlags(context, flags){
      context.commit('GETFARFLAGS', flags)
    },
    getGreenRateFlags(context, flags){
      context.commit('GETGREENFLAGS', flags)
    },
    goChangeTipStatus(context,status){
      context.commit('GOCHANGETIPSTATUS', status)
    },
    goGenerateTipStatus(context,status){
      context.commit('GOGENERATETIPSTATUS', status)
    },
    createSocket(context, socket) {
      context.commit("CREATESOCKET", socket);
    },
  },
  modules: {

  }
});
